import React from 'react';
import { string, number, shape, bool, array, object, func } from 'prop-types';
import Waypoint from 'react-waypoint';
import pathfinder from '@fiverr-private/pathfinder';
import { PortfolioPresence } from '@fiverr-private/portfolio_showcase';
import { getContext } from '@fiverr-private/fiverr_context';
import { PAGE_NAME } from '../../utils/events';
import WithImpressions from '../shared/withImpressions';
import SafePureComponent from '../shared/SafePureComponent';

const CLASS_NAME = 'portfolio-external-wrapper';

const Portfolio = ({
    portfolio,
    achievement,
    isPro,
    profilePhoto,
    hasProfilePhoto,
    impressionRef,
    collectImpressions
}, { general }) => {
    const { pathParameters, userId } = getContext();

    if (!portfolio) {
        return null;
    }

    const { gigId } = general;
    const {
        username,
        slug
    } = pathParameters;
    const seller = {
        username,
        achievement,
        is_pro: isPro,
        profile_photo: profilePhoto,
        has_profile_photo: hasProfilePhoto
    };
    const {
        portfolioProjects,
        nextProjectIds,
        projectsCount
    } = portfolio;

    if (!projectsCount){
        return null;
    }

    const origin = PAGE_NAME;
    const portfolioLink = pathfinder('user_portfolio_index',
        { user_id: username },
        { query: {
            gig: slug,
            origin
        } }
    );

    const portfolioProps = {
        projectList: portfolioProjects.concat(nextProjectIds.map((id) => ({ id }))),
        seller,
        origin,
        totalProjects: projectsCount,
        isWideTheme: true,
        gigId,
        portfolioLink,
        infinityPaging: true,
        educate: !!userId
    };

    return (
        <section className={CLASS_NAME} ref={impressionRef}>
            <Waypoint onEnter={collectImpressions}/>
            <PortfolioPresence {...portfolioProps}/>
        </section>
    );
};

Portfolio.propTypes = {
    portfolio: shape({
        portfolioProjects: array,
        nextProjectIds: array,
        projectsCount: number
    }),
    achievement: number.isRequired,
    isPro: bool,
    hasProfilePhoto: bool,
    profilePhoto: string,
    impressionRef: object,
    collectImpressions: func
};

Portfolio.contextTypes = {
    general: object
};

const impressionConfig = {
    DOMSelector: `.${CLASS_NAME} .portfolio-presence`,
    eventKey: 'portfolio_impression'
};

export { Portfolio };
export default SafePureComponent(WithImpressions(Portfolio, impressionConfig));
